export const CHECKOUT_URL = 'https://dog-grooming-instructor-ready.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/hVFwffPmKLUKqVnzn6hJQy/Diseno_sin_titulo_(72).png'

export const HERO_IMAGE_ALT =
  'Dog Grooming Instructor Ready complete system: 6 professional volumes, 100% visual teaching material and 5 professional bonus guides'

export const PRIMARY_CTA = 'GET DOG GROOMING INSTRUCTOR READY NOW'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 1 — Professional Grooming Foundations & Safe Setup' },
  { kind: 'included', label: 'Volume 2 — Coat Types, Brushing, De-Shedding & Preparation' },
  { kind: 'included', label: 'Volume 3 — Clipper Skills, Blades & Body Grooming' },
  { kind: 'included', label: 'Volume 4 — Scissor Skills, Blending & Professional Styling' },
  { kind: 'included', label: 'Volume 5 — Face, Feet, Ears, Tail & Detail Work' },
  { kind: 'included', label: 'Volume 6 — Breed Styling, Corrections & Complete Grooming Workflow' },
  { kind: 'bonus', label: 'Professional Grooming Tools, Blades & Equipment Handbook' },
  { kind: 'bonus', label: 'Canine Coat Types & Grooming Decision Guide' },
  { kind: 'bonus', label: 'Common Grooming Mistakes, Corrections & Troubleshooting Manual' },
  { kind: 'bonus', label: '30 Ready-to-Teach Dog Grooming Class Plans' },
  { kind: 'bonus', label: 'Student Skills Assessment & Progress Tracker' },
  { kind: 'included', label: '100% Visual Main Teaching System' },
  { kind: 'included', label: 'Immediate Digital Access' },
]
